import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useMemo } from "react";
import { iQueryInputElementProps } from "../models";

type Timestamp = number;

type DatePickerValue = { valueOf: () => number } | Date | null;

/** Adapts stored rule value (epoch ms) for Ant Design DatePicker. */
const timestampToDatePickerValue = (value: unknown) => {
  if (value == null || value === "") {
    return null;
  }
  if (typeof value === "number") {
    return dayjs(value);
  }
  if (value instanceof Date) {
    return dayjs(value);
  }
  if (dayjs.isDayjs(value)) {
    return value;
  }
  return dayjs(value as string | number);
};

/** Adapts DatePicker output back to stored rule value (epoch ms). */
const datePickerValueToTimestamp = (
  value: DatePickerValue,
): Timestamp | undefined => {
  if (value == null) {
    return undefined;
  }
  if (value instanceof Date) {
    return value.getTime();
  }
  return value.valueOf();
};

export const StandardDateInput = ({
  value,
  onChange,
}: iQueryInputElementProps) => {
  const datePickerValue = useMemo(
    () => timestampToDatePickerValue(value),
    [value],
  );

  return (
    <DatePicker
      showTime={{ showSecond: false }}
      className="w-full"
      placeholder="Select date"
      format="YYYY-MM-DD HH:mm"
      value={datePickerValue as any}
      onChange={(date) => {
        onChange(datePickerValueToTimestamp(date));
      }}
    />
  );
};
